import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import React, { useState, useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import { selectors as sessionSelectors } from "reducers/session";
import MainContainer from "pages/_components/MainContainer";
import DownloadListComponent from "pages/_components/product/List";
import TitleColumns from "../directDebit/_components/TitleColumns";
import DownloadItem from "./_components/ItemRow";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

const FORM_ID = "directDebit.downloadList";

const DownloadList = (props) => {
    const dispatch = useDispatch();

    const { isDesktop, fetching, downloadsList, environment } = props;

    const [downloadsToDisplay, setDownloadsToDisplay] = useState([]);
    const [fetchingMoreData, setFetchingMoreData] = useState(false);
    const row = isDesktop ? 1 : 4;
    const hasMoreData = downloadsList?.length > downloadsToDisplay.length;

    const downloadsPerBatch = isDesktop ? 10 : 5;

    const fetchMoreTransactions = () => {
        const currentLength = downloadsToDisplay.length;
        const nextLength = currentLength + downloadsPerBatch;
        const newItems = downloadsList.slice(0, nextLength);
        setDownloadsToDisplay(newItems);
    };

    useEffect(() => {
        if (downloadsList?.length) {
            setDownloadsToDisplay(downloadsList.slice(0, downloadsPerBatch));
        }
    }, [downloadsList]);

    useEffect(() => {
        if (fetching && (downloadsList && downloadsList.length === 0 || hasMoreData)) {
            setFetchingMoreData(true);
        } else {
            setFetchingMoreData(false);
        }
    }, [fetching]);

    useEffect(() => {
            const params = {
                cuit: environment?.activeEnvironmentDocument,
            };
            dispatch(accountsActions.listDirectDebitDownloads(params));
    }, []);

    const getRequest = (fileName) => {
        const params = {
            fileToDownload: fileName,
        };
        return params;
    };

    return (
        <>
            <MainContainer showLoader={fetching}>
                <div className="container">
                    {downloadsToDisplay && downloadsToDisplay.length > 0 ? (
                        <DownloadListComponent
                            fetchingWithPreviousData
                            fetching={fetching && fetchingMoreData}
                            items={downloadsToDisplay}
                            renderItem={(item) => (
                                <GridTable.Container
                                    key={`payments-item-${item}`}
                                    columns={!isDesktop && 2}
                                    columnsTemplate={isDesktop && "repeat(2, 1fr) 40px"}
                                    className={!isDesktop && "box box-shadow"}>
                                    <DownloadItem
                                        key={`transaction-${item}`}
                                        download={item}
                                        isDesktop={isDesktop}
                                        formId={FORM_ID}
                                        downloadAction={() => dispatch(accountsActions.getDirectDebitDownload(getRequest(item.fileName)))}
                                    />
                                </GridTable.Container>
                            )}>
                            {(listItem) => (
                                <GridTable>
                                    {isDesktop && (
                                        <GridTable.Header>
                                            <GridTable.Container rows={row} columnsTemplate="repeat(2, 1fr) 40px">
                                                <TitleColumns formId={FORM_ID} />{" "}
                                            </GridTable.Container>
                                        </GridTable.Header>
                                    )}
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                            className="view-more"
                                        />
                                    )}
                                </GridTable>
                            )}
                        </DownloadListComponent>
                    ) : (
                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get(`${FORM_ID}.noresults`)}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    environment: sessionSelectors.getActiveEnvironment(state),
    fetching: accountsSelectors.getFetching(state),
    downloadsList: accountsSelectors.getDirectDebitDownloadsList(state),
});
export default connect(mapStateToProps)(DownloadList);